<template>
  <header>
    <router-link to="/"><img src="../assets/images/logo.png" alt="" class="logo" /></router-link>
    <nav>
      <ul>
        <li><router-link to="/playground">Playground</router-link></li>
        <li>
          <a target="_blank" href="https://github.com/Meedev-agency/simply_wave"
            >Github</a
          >
        </li>
        <li>
          <a target="_blank" href="https://www.npmjs.com/package/simply_wave"
            >npm</a
          >
        </li>
      </ul>
    </nav>
  </header>
</template>

<script>
export default {
  name: 'HeaderComponent',
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '../assets/scss/style.scss';
header {
  width: 100%;
  position: absolute;
  height: $headerHeight;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .logo {
    height: 40px;
    margin-left: $gutter;

    &:hover {
      cursor: pointer;
    }
  }

  nav {
    margin-right: $gutter;

    ul {
      padding: 0;
      display: flex;
      align-items: center;
      column-gap: 40px;

      li {
        list-style-type: none;

        a {
          color: black;
          text-decoration: none;
        }
      }
    }
  }
}
</style>

